import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useForm } from 'react-hook-form';
import { getProfanity, updateProfanity } from '../../../../../actions/appsMoreAction';
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_LOADING, TOAST_DISMISS } from "../../../../../utils";
import { CLOUD_URL as CLOUDPATH } from '../../../../../actions/api';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const Profanity = ({ showProfanity, closeProfanity, getData }) => {

    const [downloadSample, setDownloadSample] = useState(0);
    const { handleSubmit, formState: {} } = useForm();

    const [wallId, setWallId] = useState(getData.detail?.wallId || '');

    const myRefname = useRef(null);
    const [profanityDefaultUrl, setprofanityDefaultUrl] = useState('');
    const [profanityUrl, setprofanityUrl] = useState('');
    const [profanityFileName, setprofanityFileName] = useState('');
    const [profanityFile, setprofanityFile] = useState('');
    const [profanityStatus, setprofanityStatus] = useState(0);

    const [profanityForm, setprofanityForm] = useState(0);
    const [spinner, setspinner] = useState(false);


    const profanityFilter = () => {

        const formData = new FormData();


        formData.append('profanityFile', profanityFile);
        formData.append('ownerId', localStorage.getItem('ownerId'));
        formData.append('wallId', wallId);
        formData.append('status', profanityStatus);

        if (downloadSample == 2){
            formData.append('useruploadProfanity', 1);
            formData.append('profanity_url_link', profanityUrl);
        }
        if (downloadSample != 2){
            formData.append('defaultProfanity', 1);
            formData.append('profanity_url_link', profanityDefaultUrl);
        }

        let fileInput = document.getElementById('fileupload').value;
        let allowedExtenstion = /(\.csv|\.xls|\.CSV|\.XLS)$/i;

        if (!allowedExtenstion.exec(fileInput) && fileInput.length > 0 && downloadSample != 1) {
            fileInput = '';
            TOAST_ERROR("Only csv & xls file allowed");
            return false;
        } else {
            TOAST_LOADING();
            setspinner(true);
            updateProfanity(Object.fromEntries(formData)).then((response) => {

                TOAST_DISMISS();
                if (response.data.status == true) {
                    TOAST_SUCCESS(response.data.message);
                    closeProfanity();
                } else {
                    TOAST_ERROR(response.data.message);
                }
                setspinner(false);
            }).catch((error) => {
                TOAST_DISMISS();
                TOAST_ERROR(error.message);

            })
        }


    }


    const FileChange = (e) => {
        setprofanityFile(e.target.files[0]);
        setprofanityFileName(e.target.files[0]['name']);
        setprofanityUrl(e.target.files[0]['name']);
        setDownloadSample(2);
    }


    const getProfanityData = () => {
        TOAST_LOADING();
        getProfanity(localStorage.getItem('ownerId'), wallId).then((response) => {

            if (response.data.status == true) {
                const res = response.data.response;
                setprofanityDefaultUrl(`${CLOUDPATH}app/${response.data.default_link}`)
                setprofanityUrl(res.profanity_url);
                setprofanityFileName(response.data.filename);
                setprofanityStatus(res.profanity);
                setDownloadSample(res.profanityUse ? 2 : 1);
                setprofanityForm(1);
                TOAST_DISMISS();
            }
        })
    }

    useEffect(() => getProfanityData(), [showProfanity]);


    return (
        <>
            {profanityForm ?
                <Modal show={showProfanity} onHide={closeProfanity} centered>
                    <Modal.Header className="personalize_wt" closeButton>
                        <Modal.Title className="modal-title"> Profanity</Modal.Title>
                    </Modal.Header>

                    <form onSubmit={handleSubmit(profanityFilter)} action="" className="maintainPopUp noLoader" method="post" accept-charset="utf-8">
                        <Modal.Body>
                        <div className="tabbable tabbable-tabdrop">
                            <div className="tab-content profanityStats">
                                <div className="tab-pane active">
                                    <div className="form-group">
                                        <p className="lightTxtPera">Turn on this option to auto filter the content based on a pre-set list of unwanted words.</p>
                                    </div>
                                </div>
                                <div className="tab-pane active profanityKey">
                                    <div className="portlet-body">
                                        <div className="profanity_wrap">
                                            <div className="checkbox-inline d-flex justify-content-between align-items-center w-100">

                                                <div key={downloadSample} class="form-check flex-grow-1 p-0">
                                                    <input className='form-check-input me-2' disabled={downloadSample != 2 ? true : false} onClick={(e) => setDownloadSample(e.target.checked ? 1 : 0)} type="checkbox" defaultChecked={downloadSample != 2 ? true : false} /> Use our predefined vulgar word list
                                                </div>
                                                <a href={profanityDefaultUrl} className="p-2" download="">
                                                    <FontAwesomeIcon type={'regular'} icon={'download'} iconClass="fs-4"/>
                                                </a>
                                            </div>
                                            <div className="d-flex align-items-center my-3">
                                                <div className="separator separator-solid col"></div>
                                                <div className="symbol symbol-circle">
                                                    <span className="symbol-label">OR</span>
                                                </div>
                                                <div className="separator separator-solid col"></div>
                                            </div>

                                            <div className="profanityCols my-3" >
                                                <div onClick={(e) => { myRefname.current.click() }} className="upload-area cursor-pointer">
                                                    <span className="glyphicon glyphicon-level-up"></span>
                                                    <p className="m-0">Upload your own File</p>
                                                    <input ref={myRefname} id='fileupload' accept=".csv" onChange={(e) => FileChange(e)} type="file" name="profanityFile" style={{ display: 'none' }}></input>
                                                </div>


                                                {profanityFileName ?
                                                    <div className="f-between w-100 mt-4">
                                                        <div key={downloadSample} className="form-check flex-grow-1 p-0">
                                                            <input className='form-check-input me-2' disabled={downloadSample == 2 ? true : false} onClick={(e) => setDownloadSample(e.target.checked ? 2 : 0)} defaultChecked={downloadSample == 2 ? true : false} type="checkbox" name="useruploadProfanity" value="1" /> {profanityFileName}
                                                        </div>
                                                        <a href={profanityUrl} className="p-2" download="">
                                                            <FontAwesomeIcon type={'regular'} icon={'download'} iconClass="fs-4"/>
                                                        </a>
                                                    </div>
                                                    : null}
                                            </div>

                                            <div className="formFtr">
                                                <div className="border-top pt-3 d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <label htmlFor="automoderationprofanityfilter">
                                                            Enable Profanity Filter
                                                            <OverlayTrigger overlay={<Tooltip>This will make all the posts having inappropriate or vulgar words to get disapproved automatically. You can find them later in Private Posts Section in Moderation.</Tooltip>}>
                                                                <span className="ms-2">
                                                                    <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass="text-gray-500 fs-6"/>
                                                                </span>
                                                            </OverlayTrigger>
                                                            <span className="errorMessage"></span>
                                                        </label>
                                                    </div>
                                                    <div className="toggleOnBut">
                                                        <div className="onoffswitch">
                                                            <span className="switch justify-content-center">
                                                                <label className='d-flex' htmlFor="profanityStatusNew">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="profanity"
                                                                        value="1"
                                                                        id="profanityStatusNew"
                                                                        className="onoffswitch-checkbox updateStatus"
                                                                        data-off-color="#989898"
                                                                        data-on-color="#009385"
                                                                        checked={profanityStatus}
                                                                        onClick={(e) => setprofanityStatus(e.target.checked ? 1 : 0)}
                                                                    />
                                                                    <span></span>
                                                                </label>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex align-items-center justify-content-end w-100">
                                <Button variant='secondary' onClick={(e) => closeProfanity()} type="button" className="me-2" data-bs-dismiss="modal">Cancel</Button>
                                <Button variant='primary' type="submit" className={`addMoreAnnocBtn ladda-button  ${spinner ? `spinner spinner-white spinner-right disabled` : null}`}>Apply</Button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>
                :
                null
            }
        </>
    );
};

export default Profanity;
